
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SidebarListItem',
  props: {
    label: String,
    active: Boolean,
  },
  emits: ['select'],
  setup(props, { emit }) {
    const onClick = () => emit('select');

    return {
      onClick,
    };
  },
});
